import React, { createContext, useContext, useState } from 'react';
import translations from '../i18n/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => localStorage.getItem('cw_lang') || 'es');

    const toggleLang = () => {
        const next = lang === 'es' ? 'en' : 'es';
        setLang(next);
        localStorage.setItem('cw_lang', next);
    };

    const t = (key) => translations[lang]?.[key] ?? translations['es']?.[key] ?? key;

    return (
        <LanguageContext.Provider value={{ lang, toggleLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
